import { postForm, request } from "./client";

export interface BatchRecord {
  batch_id: string;
  playbook_id: string;
  total: number;
  completed: number;
  failed: number;
  status: "pending" | "running" | "paused" | "completed" | "cancelled" | "interrupted";
  concurrency: number;
  created_at: number;
  updated_at: number | null;
}

export interface BatchListResponse {
  batches: BatchRecord[];
}

export interface ParseFileResult {
  rows: Array<{ number: string; params: Record<string, string> }>;
  column_mapping: Record<string, string>;
  phone_column: string;
}

export async function parseBatchFile(file: File, playbookId: string): Promise<ParseFileResult> {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("playbook_id", playbookId);
  return (await postForm("/batch/parse-file", fd)).json();
}

export function createBatch(
  playbook_id: string, numbers: string[], concurrency: number,
  params?: Record<string, string>,
  per_number_params?: Record<string, string>[],
  gateway?: string,
): Promise<{ batch_id: string }> {
  const body: Record<string, unknown> = { playbook_id, numbers, concurrency };
  if (params && Object.keys(params).length > 0) body.params = params;
  if (per_number_params) body.per_number_params = per_number_params;
  if (gateway) body.gateway = gateway;
  return request("/batch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function getBatch(id: string): Promise<BatchRecord> {
  return request(`/batch/${id}`);
}

export function listBatches(): Promise<BatchListResponse> {
  return request("/batches");
}

export function pauseBatch(id: string): Promise<{ batch_id: string; status: string }> {
  return request(`/batch/${id}/pause`, { method: "POST" });
}

export function resumeBatch(id: string): Promise<{ batch_id: string; status: string }> {
  return request(`/batch/${id}/resume`, { method: "POST" });
}

export function continueBatch(id: string): Promise<{ batch_id: string; status: string }> {
  return request(`/batch/${id}/continue`, { method: "POST" });
}

export function cancelBatch(id: string): Promise<{ batch_id: string; status: string }> {
  return request(`/batch/${id}`, { method: "DELETE" });
}

export function retagBatch(id: string): Promise<{ batch_id: string; retagged: number }> {
  return request(`/batch/${id}/retag`, { method: "POST" });
}

export function setBatchConcurrency(
  id: string, concurrency: number,
): Promise<{ batch_id: string; concurrency: number }> {
  return request(`/batch/${id}/concurrency`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ concurrency }),
  });
}
